import { StatisticType } from '../types/dashboard.type';

/**
 * KPIs whose dashboard value is a list (breakdowns, supply per recycler,
 * active trucks) rather than a single number, so a threshold can't be tracked
 * on them. They are not offered in the KPI limits dialog and never become a
 * target card; existing limits on them are flagged in the dialog.
 */
export const UNTRACKABLE_KPI_KEYS: ReadonlySet<string> = new Set<string>([
  StatisticType.SUPPLY_PER_RECYCLER,
  StatisticType.INCOMING_WASTE_BREAKDOWN,
  StatisticType.WASTE_TYPE_BREAKDOWN,
  StatisticType.ACTIVE_TRUCKS,
]);

export const isTrackableKpi = (key: string): boolean => !UNTRACKABLE_KPI_KEYS.has(key.toLowerCase());

/** KPI options for the limits dialog: every single-number statistic. */
export const TRACKABLE_KPI_OPTIONS: StatisticType[] = Object.values(StatisticType).filter(isTrackableKpi);

/** A KPI value usable as a target reading, or null when the month has none. */
export function kpiTargetValue(source: object | null | undefined, key: string): number | null {
  const raw = source ? (source as Record<string, unknown>)[key.toLowerCase()] : undefined;
  return typeof raw === 'number' && Number.isFinite(raw) ? raw : null;
}
